// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseApprovedPage_root__EFyOg"};